/**
 * <TutorOfferSkeleton> — la forme d'une offre ouverte par un lien pendant qu'elle charge : le
 * titre, le titre de l'offre, ses séances, la première séance.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"

export function TutorOfferSkeleton() {
    return (
        <Stack gap="4">
            <Skeleton textSize="text-2xl" width={260} />
            <Stack gap="3">
                <Skeleton textSize="text-lg" width={180} />
                <Stack gap="1">
                    <Skeleton textSize="text-md" width="75%" />
                    <Skeleton textSize="text-md" width="75%" />
                </Stack>
                <Skeleton textSize="text-md" width={240} />
            </Stack>
        </Stack>
    )
}
